import { NumberFormatter } from 'field-kit';

/**
 * A FieldKit.NumberFormatter that caches default region, locale, and attr values
 * for performance.
 */
export class DefaultCachingNumberFormatter extends NumberFormatter {
  constructor() {
    super();
    this._defaultCache = {};
  }
  setCountryCode(countryCode) {
    this._defaultCache = {};
    return super.setCountryCode(countryCode);
  }
  setCurrencyCode(currencyCode) {
    this._defaultCache = {};
    return super.setCurrencyCode(currencyCode);
  }
  setLocale(locale) {
    this._defaultCache = {};
    return super.setLocale(locale);
  }
  _get(attr) {
    const attrKey = `_${attr}`;
    const value = this[attrKey];
    if (value !== null && value !== undefined) {
      return value;
    }
    if (this._defaultCache[attrKey] === undefined) {
      this._defaultCache[attrKey] = super._get(attr);
    }
    return this._defaultCache[attrKey];
  }
  _currencyDefaults() {
    if (this._defaultCache.currencyDefaults === undefined) {
      this._defaultCache.currencyDefaults = super._currencyDefaults();
    }
    return this._defaultCache.currencyDefaults;
  }
  _regionDefaults() {
    if (this._defaultCache.regionDefaults === undefined) {
      this._defaultCache.regionDefaults = super._regionDefaults();
    }
    return this._defaultCache.regionDefaults;
  }
  _localeDefaults() {
    if (this._defaultCache.localeDefaults === undefined) {
      this._defaultCache.localeDefaults = super._localeDefaults();
    }
    return this._defaultCache.localeDefaults;
  }
}